import { render, staticRenderFns } from "./SendCertificate.vue?vue&type=template&id=3b0cde7d&scoped=true"
import script from "./SendCertificate.vue?vue&type=script&lang=js"
export * from "./SendCertificate.vue?vue&type=script&lang=js"
import style0 from "./SendCertificate.vue?vue&type=style&index=0&id=3b0cde7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0cde7d",
  null
  
)

export default component.exports